module.exports = __webpack_public_path__ + "static/media/avatar.c7b5f6a0.png";